import React from 'react';
import { Button } from '@insurancemenu/imenu-components-lib';
import { createStyles } from './styles';

export interface ResetBlockProps {
  resetFilter: () => void;
}
const ResetBlock = ({ resetFilter }: ResetBlockProps): JSX.Element => {
  const classes = createStyles();
  return (
    <div className={classes.messageBlock}>
      <p className={classes.message}>There are no cards that match filter options.</p>
      <Button color="primary" onClick={resetFilter} size="medium" type="contained">
        Reset filter
      </Button>
    </div>
  );
};

export default ResetBlock;
